// @generated by protoc-gen-connect-es v1.1.2 with parameter "target=js+dts,import_extension=none"
// @generated from file identity/v1/settings_service.proto (package identity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ChangeMerchantSettingsStatusRequest, ChangeMerchantSettingsStatusResponse, CreateAndPromoteMerchantSettingsRequest, CreateAndPromoteMerchantSettingsResponse, CreateExperimentRequest, CreateExperimentResponse, CreateMerchantSettingsRequest, CreateMerchantSettingsResponse, CreateSegmentRequest, CreateSegmentResponse, DeleteSegmentRequest, DeleteSegmentResponse, GetActiveExperimentRequest, GetActiveExperimentResponse, GetActiveMerchantSettingsRequest, GetActiveMerchantSettingsResponse, GetAllActiveMerchantSettingsRequest, GetAllActiveMerchantSettingsResponse, GetAllExperimentsRequest, GetAllExperimentsResponse, GetExperimentResultsListRequest, GetExperimentResultsListResponse, GetExperimentResultsRequest, GetExperimentResultsResponse, GetMerchantSettingsForAdminRequest, GetMerchantSettingsForAdminResponse, GetMerchantSettingsForBundleRequest, GetMerchantSettingsForBundleResponse, GetMerchantSettingsListRequest, GetMerchantSettingsListResponse, GetMerchantSettingsRequest, GetMerchantSettingsResponse, GetReferenceDataForMppSettingsRequest, GetReferenceDataForMppSettingsResponse, GetStratusConfigForJpmppMidRequest, GetStratusConfigForJpmppMidResponse, PromoteMerchantSettingsRequest, PromoteMerchantSettingsResponse, UpdateExperimentRequest, UpdateExperimentResponse, UpdateMerchantSettingsRequest, UpdateMerchantSettingsResponse } from "./settings_service_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service identity.v1.MerchantSettingsService
 */
export const MerchantSettingsService = {
  typeName: "identity.v1.MerchantSettingsService",
  methods: {
    /**
     * @generated from rpc identity.v1.MerchantSettingsService.GetMerchantSettings
     */
    getMerchantSettings: {
      name: "GetMerchantSettings",
      I: GetMerchantSettingsRequest,
      O: GetMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc identity.v1.MerchantSettingsService.GetMerchantSettingsList
     */
    getMerchantSettingsList: {
      name: "GetMerchantSettingsList",
      I: GetMerchantSettingsListRequest,
      O: GetMerchantSettingsListResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get Setting by Settings Id used by TechOps
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetMerchantSettingsForAdmin
     */
    getMerchantSettingsForAdmin: {
      name: "GetMerchantSettingsForAdmin",
      I: GetMerchantSettingsForAdminRequest,
      O: GetMerchantSettingsForAdminResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get settings used by
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetMerchantSettingsForBundle
     */
    getMerchantSettingsForBundle: {
      name: "GetMerchantSettingsForBundle",
      I: GetMerchantSettingsForBundleRequest,
      O: GetMerchantSettingsForBundleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Create settings will take merchant setting object as well as createBy and updateBy from IDA JWT
     *
     * @generated from rpc identity.v1.MerchantSettingsService.CreateMerchantSettings
     */
    createMerchantSettings: {
      name: "CreateMerchantSettings",
      I: CreateMerchantSettingsRequest,
      O: CreateMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * For promoting a settings from DRAFT to Active or Pending (future)
     *
     * @generated from rpc identity.v1.MerchantSettingsService.PromoteMerchantSettings
     */
    promoteMerchantSettings: {
      name: "PromoteMerchantSettings",
      I: PromoteMerchantSettingsRequest,
      O: PromoteMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * For publishing a settings from MPP. This will create and promote a new settings together.
     *
     * @generated from rpc identity.v1.MerchantSettingsService.CreateAndPromoteMerchantSettings
     */
    createAndPromoteMerchantSettings: {
      name: "CreateAndPromoteMerchantSettings",
      I: CreateAndPromoteMerchantSettingsRequest,
      O: CreateAndPromoteMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Endpoint to create a new merchant segment. Used in MPP Checkout Settings.
     *
     * @generated from rpc identity.v1.MerchantSettingsService.CreateSegment
     */
    createSegment: {
      name: "CreateSegment",
      I: CreateSegmentRequest,
      O: CreateSegmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Change merchant settings status to ACTIVE or PENDING
     *
     * @generated from rpc identity.v1.MerchantSettingsService.ChangeMerchantSettingsStatus
     */
    changeMerchantSettingsStatus: {
      name: "ChangeMerchantSettingsStatus",
      I: ChangeMerchantSettingsStatusRequest,
      O: ChangeMerchantSettingsStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get currently active merchant settings for specific merchant id
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetActiveMerchantSettings
     */
    getActiveMerchantSettings: {
      name: "GetActiveMerchantSettings",
      I: GetActiveMerchantSettingsRequest,
      O: GetActiveMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get all active merchant settings
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetAllActiveMerchantSettings
     */
    getAllActiveMerchantSettings: {
      name: "GetAllActiveMerchantSettings",
      I: GetAllActiveMerchantSettingsRequest,
      O: GetAllActiveMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get reference data for mpp settings request
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetReferenceDataForMppSettings
     */
    getReferenceDataForMppSettings: {
      name: "GetReferenceDataForMppSettings",
      I: GetReferenceDataForMppSettingsRequest,
      O: GetReferenceDataForMppSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Patch on merchant settings
     *
     * @generated from rpc identity.v1.MerchantSettingsService.UpdateMerchantSettings
     */
    updateMerchantSettings: {
      name: "UpdateMerchantSettings",
      I: UpdateMerchantSettingsRequest,
      O: UpdateMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete Merchant Settings Segment
     *
     * @generated from rpc identity.v1.MerchantSettingsService.DeleteSegment
     */
    deleteSegment: {
      name: "DeleteSegment",
      I: DeleteSegmentRequest,
      O: DeleteSegmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Return Stratus config against a JPMPP mid
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetStratusConfigForJpmppMid
     */
    getStratusConfigForJpmppMid: {
      name: "GetStratusConfigForJpmppMid",
      I: GetStratusConfigForJpmppMidRequest,
      O: GetStratusConfigForJpmppMidResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Create an experiment
     *
     * @generated from rpc identity.v1.MerchantSettingsService.CreateExperiment
     */
    createExperiment: {
      name: "CreateExperiment",
      I: CreateExperimentRequest,
      O: CreateExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get currently active experiment
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetActiveExperiment
     */
    getActiveExperiment: {
      name: "GetActiveExperiment",
      I: GetActiveExperimentRequest,
      O: GetActiveExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List all experiments
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetAllExperiments
     */
    getAllExperiments: {
      name: "GetAllExperiments",
      I: GetAllExperimentsRequest,
      O: GetAllExperimentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Update experiment status
     *
     * @generated from rpc identity.v1.MerchantSettingsService.UpdateExperiment
     */
    updateExperiment: {
      name: "UpdateExperiment",
      I: UpdateExperimentRequest,
      O: UpdateExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get Experiment Result
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetExperimentResults
     */
    getExperimentResults: {
      name: "GetExperimentResults",
      I: GetExperimentResultsRequest,
      O: GetExperimentResultsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get Experiment Results List
     *
     * @generated from rpc identity.v1.MerchantSettingsService.GetExperimentResultsList
     */
    getExperimentResultsList: {
      name: "GetExperimentResultsList",
      I: GetExperimentResultsListRequest,
      O: GetExperimentResultsListResponse,
      kind: MethodKind.Unary,
    },
  }
};

